export const canUseDOM = (): boolean =>
    !!(
        // tslint:disable-next-line:no-typeof-undefined
        (typeof window !== 'undefined' && window.document && window.document.createElement)
    );
